import { useEffect } from 'react';

import { useBranding } from '../hooks/useBranding/useBranding';
import { SearchParamKey } from '../services/urlParams/urlParams';
import { urlParamHook } from '../services/urlParams/urlParamsService';

function BrandingGuard({ children }: { children: JSX.Element }): JSX.Element {
  const { initializeBranding } = useBranding();

  useEffect(() => {
    const { savedParam: leadChannelCode } = urlParamHook(
      SearchParamKey.leadChannelCode,
    );

    initializeBranding(leadChannelCode);
  }, []);

  return children;
}

export default BrandingGuard;
